import { useCallback } from "react";

import { section } from "../components/dynamicEditor/components/portalDynamicComponent";
import { MindflashSettings, RepSettings } from "../models/settings";
import { useRepPortalApi } from "./repPortalApi";

export function useSettingsApi() {
	const { Get } = useRepPortalApi();

	/**
	 * Get the configuration settings from the controller
	 * @param branchId
	 */
	const getSettings = useCallback(
		function (branchId?: number) {
			return Get<RepSettings>("GetSettings", { branchId });
		},
		[Get],
	);

	/**
	 * Get the configuration settings specific to rep from the controller
	 * @param repId
	 */
	const getRepSettings = useCallback(
		function (repId: number) {
			return Get<RepSettings>("GetRepSettings", { repId });
		},
		[Get],
	);

	/**
	 * Get the mindflash settings specific to rep from the controller
	 * @param repId
	 */
	const getMindflashSettings = useCallback(
		function (repId: number) {
			return Get<MindflashSettings>("GetMindflashSettings", { repId });
		},
		[Get],
	);

	const getDynamicComponents = useCallback(
		function () {
			return Get<section[]>("GetDynamicComponents").then(order);

			function order(sections: section[]) {
				if (!sections) return;
				for (const section of sections) {
					section.childSections?.sort((a, b) => a.ordinal - b.ordinal);
					section.components?.sort((a, b) => a.ordinal - b.ordinal);
					order(section.childSections);
				}
				return sections;
			}
		},
		[Get],
	);

	return {
		getSettings,
		getRepSettings,
		getMindflashSettings,
		getDynamicComponents,
	};
}
